import React from 'react';

import { useIntl } from 'react-intl';

import { Profile } from '@atlaskit/navigation-system/top-nav-items/profile';

import { useImageState } from '../../../hooks/use-image-state';
import { type AccountMenuTriggerProps, messages } from './index';

// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
export const AccountMenuTriggerNav4: React.ComponentType<AccountMenuTriggerProps> =
	React.forwardRef(({ picture, email, trustPicture = false, ...props }, ref) => {
		const intl = useIntl();
		const state = useImageState(picture || '');

		const tooltip = intl.formatMessage(messages.triggerTooltip);

		return (
			<Profile
				{...props}
				isSelected={props['aria-expanded']}
				ref={ref}
				label={email || tooltip}
				src={trustPicture || state === 'loaded' ? picture : undefined}
			/>
		);
	});
